import React, { Fragment, useState } from "react";
import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import PencilOutline from "mdi-material-ui/PencilOutline";
import DeleteOutline from "mdi-material-ui/DeleteOutline";
import { hijriMonthsFull } from "@core/layouts/utils";
import DialogModal from "@core/components/dialogmodal";
import QuickSearchToolbar from "views/components/QuickSearchToolbar";
import { isPermissionAllow } from "@core/utils/IsPermissionAllow";

const HijriCalendraList = (props) => {
  const {
    handleDeleteModal,
    deleteOpen,
    handleOpen,
    hijriCalendarList,
    pageSize,
    searchText,
    pageNumber,
    setPageSize,
    setSearchText,
    setPageNumber,
    totalRecord,
    permission,
    role,
  } = props;
  const [deleteId, setDeleteId] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);

  const handleEdit = (id) => {
    handleOpen("edit", id);
  };

  const handleDelete = (id) => {
    handleDeleteModal();
    setDeleteId(id);
  };

  const handleSearch = (searchValue) => {
    setSearchText(searchValue);
  };

  const columns = [
    {
      flex: 0.4,
      minWidth: 80,
      field: "index",
      headerName: "Index",
    },
  
    {
      flex: 1,
      minWidth: 170,
      field: "month_year",
      headerName: "Month-Year",
      renderCell: ({ row }) => {
        const splitdata = _.split(row.month_year, "-", 2);
        const match = _.find(hijriMonthsFull, ["no", splitdata[0]]);

        return (
          <Typography sx={{ fontSize: "0.92rem !important" }}>
            {`${match.name}-${splitdata[1]}`}
          </Typography>
        );
      },
    },
    {
      flex: 1,
      minWidth: 170,
      field: "days",
      headerName: "Days",
    },

    {
      flex: 0.8,
      minWidth: 100,
      field: "action",
      headerName: "Actions",
      renderCell: ({ row }) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {((permission.edit && role === "2") || role === "1") && (
                <IconButton onClick={() => handleEdit(row.id)}>
                  <PencilOutline fontSize="medium" />
                </IconButton>
              )}
              {((permission.delete && role === "2") || role === "1") && (
                <IconButton onClick={() => handleDelete(row.id)}>
                  <DeleteOutline fontSize="medium" />
                </IconButton>
              )}
            </Box>
          </Box>
        );
      },
    },
  ];
  const removeaction =
    !permission.edit && !permission.delete && role === "2"
      ? _.dropRight(columns)
      : columns;
  const assemList = hijriCalendarList.map((data, index) => {
    return {
      index: index + pageSize * pageNumber + 1,
      id: data.id,
      month_year: data.month_year,
      days: data.days,
    };
  });

  return (
    <Fragment>
      <Card>
        <DataGrid
          hideFooterSelectedRowCount
          autoHeight
          localeText={{ noRowsLabel: "No results found" }}
          page={pageNumber}
          rowCount={Number(totalRecord)}
          pageSize={pageSize}
          columns={removeaction}
          rows={assemList}
          rowsPerPageOptions={[10, 25, 50]}
          components={{ Toolbar: QuickSearchToolbar }}
          onPageChange={(newPageNumber) => setPageNumber(newPageNumber)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSelectionModelChange={(rows) => setSelectedRows(rows)}
          pagination
          paginationMode="server"
          checkboxSelection={isPermissionAllow(permission.delete, role)}
          disableSelectionOnClick
          componentsProps={{
            toolbar: {
              handleOpen: () => handleOpen("add", ""),
              title: isPermissionAllow(permission.edit, role)
                ? "Add Hijri Calendar"
                : "",
              isSearch: false,
              value: searchText,
              selectedRows: selectedRows,
              clearSearch: () => handleSearch(""),
              onChange: (event) => handleSearch(event.target.value),
              onClickDelete: () => handleDeleteModal(),
              multiDelete: isPermissionAllow(permission.delete, role),
            },
          }}
          sx={{
            ".MuiTablePagination-displayedRows": {
              marginTop: "1rem",
            },
            ".MuiTablePagination-selectLabel": {
              marginTop: "1.1rem",
            },
            ".MuiInputBase-root": {
              marginTop: "0.2rem",
            },
          }}
        />
      </Card>

      {deleteOpen && (
        <DialogModal
          open={deleteOpen}
          handleClose={() => handleDeleteModal()}
          handleDelete={() =>
            handleDeleteModal(
              selectedRows && selectedRows.length === 0
                ? [deleteId]
                : selectedRows
            )
          }
        />
      )}
    </Fragment>
  );
};

export default HijriCalendraList;
